/**
 * Generic API Types
 * Common types for API request/response handling
 */

export interface ApiError {
  status: 'error';
  message: string;
  code?: string;
}

export type ApiResponse<T> = T | ApiError;

// Type guard for error responses
export function isApiError(response: any): response is ApiError {
  return response && response.status === 'error' && typeof response.message === 'string';
}
